import clsx from 'clsx';
import RoundedButton, { ColorStyle } from 'components/RoundedButton';
import { ChangeEvent } from 'react';
import Button, { ButtonSize } from '../Button';
import styles from './inputWithButton.module.css';

interface InputWithButtonProps {
  inputPlaceholder?: string;
  inputValue: string;
  inputColor?: 'transparent' | 'darkBlue' | 'white';
  hideButton?: boolean;
  buttonText?: string;
  buttonColor?: string;
  buttonStyle?: keyof typeof ColorStyle | undefined;
  styles2026?: boolean;
  buttonSize2026?: ButtonSize;
  loading?: boolean;
  disabled?: boolean;
  onClickButton?: () => void;
  onChangeInput?: (e: ChangeEvent<HTMLInputElement>) => void;
  readOnly?: boolean;
}

export const InputWithButton = ({
  inputPlaceholder,
  inputValue,
  inputColor = 'white',
  buttonText,
  buttonColor,
  buttonStyle,
  hideButton,
  styles2026,
  buttonSize2026 = 'Large',
  loading,
  disabled,
  onClickButton,
  onChangeInput,
  readOnly,
}: InputWithButtonProps) => {
  return (
    <div
      className={clsx(
        styles.inputWithbutton,
        styles2026 && styles.styles2026,
        inputColor && styles[`inputColor__${inputColor}`],
        buttonSize2026 && styles[`buttonSize__${buttonSize2026}`],
      )}
    >
      <input
        id={`input-with-button-${buttonText}`}
        name="input-with-button"
        type="text"
        value={inputValue}
        placeholder={inputPlaceholder}
        readOnly={readOnly}
        onChange={(e) => onChangeInput && onChangeInput(e)}
      />

      {!hideButton && !styles2026 && (
        <div className={styles.button}>
          <RoundedButton
            colorOverride={buttonColor}
            colorStyle={buttonStyle}
            onClick={() => onClickButton && onClickButton()}
          >
            {buttonText}
          </RoundedButton>
        </div>
      )}

      {!hideButton && styles2026 && (
        <div className={styles.button}>
          <Button
            type="submit"
            buttonStyle="SingleInputForm"
            buttonSize={buttonSize2026}
            disabled={disabled}
            loading={loading}
            onClick={() => onClickButton && onClickButton()}
          >
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default InputWithButton;
